<template>
<div>
  <div v-if="!fetchingAvailability" id="table-wrapper">
    <grid :others='others' :columns="tableConfigs.columns" :source.sync="arrayToTable" :options="options" :lang="$root.token.idLingua" :name="name" 
    :selectParameter="$Behaviors.focusBy()" :select="focus" :rowClick="rowClicked" @API="assignGridAPI" @ready="setGridHeight"></grid>
    
    <transition name="fade">
      <div id="purchasePopup" v-show="chooseQty" :style="popupHeight" style="position: absolute; left: 77px; max-width: 200px; width: 200px; font-size: small;
        border-color: rgb(167, 199, 220); background-color: rgb(220, 235, 245); z-index: 9999; border-style: solid; border-width: 0.1px;">
        <div class="popup-arrow-border"></div>
        <div class="popup-arrow"></div>
        <div style="height: 30px; color: rgb(107, 106, 106); font-size: 15px; text-align: center; vertical-align: middle; border-bottom-style: solid;
                    border-bottom-width: 1px; border-color: rgb(204, 204, 204); box-shadow: rgb(228, 243, 251) 0px 1px 0px;">
          <div>  
            <div style="margin-top: 4px; float: left; margin-left: 10px;">{{$Jed.firstUpperTranslate('purchase')}}</div>
            <div style="cursor: pointer; float: right; margin-right: 5px; margin-top: 2px;" @click="closePurchasePopup()">
              <i :class="$root.icons.close"></i>
            </div>
          </div>
        </div>
        <div style="margin-left: 10px; margin-right: 10px;">
          <div class="truncEllipsisMultiline">{{purchaseDes}}</div>
          <div style="font-size: 13px; padding-left: 4px; overflow: hidden; text-overflow: ellipsis;">{{$Jed.firstUpperTranslate('code') + ': ' + purchaseSid}}</div>
          <cfg cid="purchasePopup.prezzo" tag='div'>
            <div v-if="purchasePrice" style="font-size: 13px; padding-left: 4px; overflow: hidden; text-overflow: ellipsis;">{{$Jed.firstUpperTranslate('price') + ': ' + purchasePrice}}</div>
          </cfg>
         
          <div class="input-group" style="padding: 7px;">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default dyn-btn-number" data-type="minus" data-field="quant[1]">
                  <span :class="this.$root.icons.minus"></span>
              </button>
            </span>

            <input type="number" id="popupquantita2Id" name="quant[1]" class="form-control dyn-input-number" 
                    style="text-align: center;" value="" @keydown.enter.prevent> 

            <span class="input-group-btn">
              <button type="button" class="btn btn-default dyn-btn-number" data-type="plus" data-field="quant[1]">
                  <span :class="this.$root.icons.plus"></span>
              </button>
            </span>
          </div>

          <div style="display: flex; align-items: center; justify-content: center;">
            <button type="button" class="btn btn-default" style="font-size: 25px;" @click="putInCart()">
              <span :class="this.$root.icons.cart_in"></span>
            </button>
          </div>
        </div>
      </div> 
    </transition>
  </div>
  <!--loader per caricamento tabella se availability è usata-->
  <div style="position: absolute; top: 20%; left: 50%;" v-if="fetchingAvailability" class="sk-cube-grid">
    <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
    <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
  </div>
</div>
</template>  

<script>
import Grid from "../dynamic/jqwGridWrapper/jqwGridWrapper.vue";
import { eventBus } from "../../eventbus.js";
import PopoverAlert from "./popoverWrapper/Popover.vue";
import utils from '../../../utils/utilities.js'
import Cfg from "../dynamic/ConfigurableComponent.vue";
import viewer_mixin from '../../mixins/viewer_mixin.js';
//import deepExtend from "deep-extend";

export default {
  props: {
    arrayToTable: Array, 
    focus: String,
    name: String
  },
  components: {
    Grid,
    PopoverAlert,
    Cfg
  },
  mounted: function(){
    var vm = this;
    if(vm.focus != null){
      vm.$nextTick(function(){
        vm.scrollToSelection();
      })
    }
    // create tooltip.
    $("#"+this.name).jqxTooltip();
  },
  created: function() {
    var vm = this;
    this.$emit("API", {scrollToSelection: this.scrollToSelection})

    eventBus.$on("refreshDynTableGridValues", (qty, obj) => {
        const idx = vm.arrayToTable.indexOf(obj);  
        if( idx != null && idx >= 0){
          vm.arrayToTable[idx]['qca'] = ((qty && qty > 0) ? qty : '');
          $("#popupquantita2Id").val(((qty && qty > 0) ? qty : ''));
        } 
        $('#'+vm.name).jqxGrid('updatebounddata','cells');
    });

    eventBus.$on("closePurchasePopup", () => {
      vm.closePurchasePopup();
    });

    $(window).mousedown(function(e) { //al rilascio del mouse su una qualunque area della finestra chiudo il popup di acquisto
      vm.closePurchasePopup();
    });
  },
  mixins: [viewer_mixin],
  data: function() {
    var vm = this;
    return {
      tableConfigs: {
        ID: "detailTable",
        highlighting_parameter: this.$Behaviors.focusBy(),
        title: "WrapperGrid",
        label_title: "",
        visible: true,
        columns: {
          configs: { 
            typ: {
              position: 1,
              text: '',
              iconcolumn: true,
              geticonclass: function(data_row, index) {
                return vm.$root.prod_icons[data_row.typ] ? vm.$root.prod_icons[data_row.typ].icn : vm.$root.icons.plus;
              },
              visible: true,
              editable: false,
              width: "2%", 
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj) {
                eventBus.$emit("openDetailModal", obj);
              }
            },
            pur: {
              position: 2,
              text: '',
              iconcolumn: true,
              customicon: true,
              setcustomicon: function(data_row) {
                if(vm.$root.blockCart){
                  return "";
                }else{
                  //l'icona carrello c'è solo per prodotti vendibili. Il prezzo può non esserci
                  if(data_row.salable){ 
                    if (data_row['qca'] != null && data_row['qca'] != '') {
                      return  "<i class='"+vm.$root.icons.cart + " icon-stack-1x' style='color: #f5a000; font-weight:bold;'></i>"; 
                    }else {
                      return "<i class='"+ vm.$root.icons.cart +" icon-stack-1x'></i>";
                    }
                  }
                  return "";
                }
              },
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj, event) { 
                if(vm.$root.blockCart){
                  return;
                }else{
                  vm.cartClick(obj, event);
                }
              },
              hidden: vm.$root.blockCart
            },
            val: {
              position: 3,
              iconcolumn: true,
              customicon: true,
              text: '',
              setcustomicon: function(data_row) {
                if(data_row.val != null){ 
                  if(data_row.val[0].sv && data_row.val[0].ev){
                    return "<span style='position: relative; display: inline-block; width: 2em;'>"+
                            "<i class='"+vm.$root.icons.val_from+" icon-stack icon-stack-1x' style='padding-right: 17px;'></i>"+
                            "<i class='"+vm.$root.icons.val_to+" icon-stack icon-stack-1x'></i>"+ 
                            "</span>";
                  }else if(data_row.val[0].sv){
                    return "<i class='"+vm.$root.icons.val_from+" icon-stack-1x'></i>";
                  }else if(data_row.val[0].ev){
                    return "<i class='"+vm.$root.icons.val_to+" icon-stack-1x'></i>";
                  }
                }
                return "";
              },
              visible: true,
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj) {
                if(obj.val != null){
                  eventBus.$emit("openDetailModal", obj);
                }
              },
              datafield: "val"
            },
            doc: {
              position: 4,
              iconcolumn: true,
              text: '',
              geticonclass: function(data_row, index) {
                if(data_row.doc != null){
                  return vm.$root.icons.attach;
                }
                return "";
              },
              visible: true,
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj) {
                if(obj.doc != null){
                  eventBus.$emit("openDetailModal", obj);
                }
              },
              datafield: "doc"
            },
            not: {
              position: 5,
              iconcolumn: true,
              text: '',
              geticonclass: function(data_row, index) {
                if((data_row.not != null && data_row.not != " " || data_row.pnot != null) || (data_row.notc != null && data_row.notc != " ")){
                   return vm.$root.icons.info_i;
                }
                return "";
              },
              visible: true,
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj) {
                if(obj.not != null || obj.notc != null){
                  eventBus.$emit("openDetailModal", obj);
                }
              },
              datafield: "not"
            },
            alt: {
              position: 6,
              iconcolumn: true,
              text: '',
              geticonclass: function(data_row, index) { 
                if(data_row.att_o != null){
                    return vm.$root.icons.other;
                }
                return "";
              },
              visible: true,
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              onclick: function(obj) {
                if(obj.att_o != null){
                  eventBus.$emit("openDetailModal", obj);
                }
              }
            },
            dis: {
              position: 7,
              text: '',
              iconcolumn: true,
              geticonclass: function(data_row, index) {
                //gestione disponibilità tramite proprietà recuperata dalla search by father
                if(data_row.ava){ 
                  return vm.$root.icons.circle; //true = "Buona"
                }else{ //false o null = altri casi o record non trovato
                  return vm.$root.icons.empty_circle;
                }
              },
              visible: true,
              editable: false,
              width: "2%",
              searchable: false,
              filterable: false,
              sortable: false,
              align: "center",
              datafield: "dis"
            },
            pos: {
              text: "position",
              position: 8,
              visible: true,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              sortBy: "sor",
              datafield: "pos",
              type: "string",
              cellsrenderer: function (data_row, datafield, value) {
                if(value)return '<div style="text-align: center; margin-top: 10px;">' + value + '</div>';
              }
            },
            sid: {
              text: "code",
              position: 9,
              visible: true,
              editable: false,
              width: "10%",
              searchable: false,
              sorting: true,
              datafield: "sid"
            },
            spi: {
              text: "substitute code",
              position: 9.5,
              visible: true,
              editable: false,
              width: "12%",
              searchable: false,
              sorting: true,
              datafield: "spi"
            },
            des: {
              text: "description",
              position: 10,
              visible: true,
              editable: false,
              width: "22%",
              searchable: false,
              sorting: true,
              datafield: "des",
              tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                if((datarow.cco && datarow.cco > 0) || datarow.lin){
                    return "<div class='jqx-grid-cell-left-align' style='margin-top: 11.5px; text-decoration: underline;'><a href='#' id='des_"+row+"'>"+value+"</a></div>"
              
                } else {
                  return "<div class='jqx-grid-cell-left-align' style='margin-top: 11.5px;'>"+value+"</div>"
                }
              },
              onclick: function(obj) {
                if(obj.cco && obj.cco > 0){
                  vm.$root.navigateTo(obj.sid, obj.fid);
                }
                if(obj.lin){
                  vm.$root.showOnlyImg = true;
                  vm.$root.toShow = obj.gra
                  vm.loadContentSpecial(obj.gra)
                }
              }
            },
            spe: {
              text: "specification",
              position: 11,
              visible: true,
              editable: false,
              width: "12%",
              searchable: false,
              sorting: true,
              datafield: "spe"
            },
            qty: {
              text: "qty",
              position: 12,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              datafield: "qty",
              type: "number",
              cellsrenderer: function (data_row, datafield, value) {
                if(value)return '<div style="text-align: center; margin-top: 10px;">' + value + '</div>';
              }
            },
            qca: {
              text: "qca",
              position: 13,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              datafield: "qca",
              type: "number",
              cellsrenderer: function (data_row, datafield, value) {
                if(value){
                  if(vm.$Components["WrapperGrid"].columns.qtb.visible){
                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px; color: #f5a000; font-weight: bold;">' + Number(value).toLocaleString() + '</span></div></div>';
                  }else{
                    return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px">' + Number(value).toLocaleString() + '</span></div></div>';
                  }
                }
              }
            },
            qtb: {
              text: "qtb",
              position: 13.5,
              editable: false,
              width: "20%",
              searchable: false,
              sorting: true,
              type: "numberinput",
              datafield: "qtb",
              mfncolumn: true, //multi function column
              setmfn: function(data_row, i){
                if(data_row.salable){
                  vm.minQuantity = data_row.mqt;
                  var qtyval = data_row.qtc ? (data_row.qca > data_row.qtc ? data_row.qca : data_row.qtc) : data_row.qca ? data_row.qca : data_row.mqt;
                  
                  return '<div class="input-group" style="padding: 3px;">'+
                            '<span id="quant_minus_span" class="input-group-btn">'+
                              '<button id="quant_minus_btn" type="button" class="btn btn-default dyn-btn-number" data-type="minus" data-field="qtb_quant['+i+']">'+
                                  '<span id="quant_minus_ico" class="'+vm.$root.icons.minus+'"></span>'+
                              '</button>'+
                            '</span>'+

                            '<input type="number" id="qtb_quantitaId'+i+'" name="qtb_quant['+i+']" class="form-control dyn-input-number"'+
                                  'style="text-align: center;" value="'+ qtyval +'" min="'+ vm.minQuantity +'" max="'+ vm.maxQuantity +'"  @keydown.enter.prevent>'+

                            '<span id="quant_plus_span" class="input-group-btn">'+
                              '<button id="quant_plus_btn" type="button" class="btn btn-default dyn-btn-number" data-type="plus" data-field="qtb_quant['+i+']">'+
                                  '<span id="quant_plus_ico" class="'+vm.$root.icons.plus+'"></span>'+
                              '</button>'+
                            '</span>'+
                          '</div>'+
                          '<span id="quant_in_cart_span" class="input-group-btn">'+
                            '<button id="quant_in_cart_span" type="button" class="btn btn-default" style="font-size: 18px; max-height: 34px;">'+
                              '<span id="quant_in_cart_span" class="'+vm.$root.icons.cart_in+'"></span>'+
                            '</button>'+
                          '</span>'
                }else{
                  return ""
                }
              },
              onclick: function(obj, event, i){
                if(event.target.id.includes('plus') || event.target.id.includes('minus')){
                  vm.manageCounterInsideGrid(obj, i);
                }
                if(event.target.id.includes('in_cart')){
                  vm.minQuantity = obj.mqt;
                  vm.product = {
                    cod: obj.sid,
                    spi: obj.spi,
                    qty: obj.qty && obj.qty >= obj.mqt ? obj.qty : obj.mqt,
                    descr: obj.spdes ? obj.spdes : obj.des,
                    unitmis: obj.uni,
                    refObj: obj,
                    csy: vm.$root.token.valuta,
                    mqt: obj.mqt
                  };
                  vm.putInCartInsideGrid(i);
                }
              }
            },
            tfq: {
              text: "quantity on drawing",
              position: 12.5,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              datafield: "tfq",
              type: "number",
              cellsrenderer: function (data_row, datafield, value) {
                if(value)return '<div style="text-align: center; margin-top: 10px;">' + value + '</div>';
              }
            },
            sor: {
              text: "sor",
              position: 12.5,
              editable: false,
              searchable: false,
              sorting: true,
              datafield: "sor",
              type: "number"
            },
            priO: {
              text: "price",
              position: 14,
              hidden: vm.$root.token.hidePrices, 
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              type: "number",
              datafield: 'origin',
              cellsalign: 'right', 
              tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                if(value && value != ""){
                  var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                  return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                } else {
                  return ""
                }
              }
            },
            pri: {
              text: "discount price",
              position: 14.5,
              hidden: vm.$root.token.hidePrices,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              type: "number",
              datafield: 'pri',
              cellsalign: 'right', 
              tobecellsrenderered: function(datarow, row, columnfield, value, defaulthtml, columnproperties){
                if(value && value != ""){
                  var csy = datarow.csy ? datarow.csy : vm.$root.token.valuta
                  return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: ' + columnproperties.cellsalign + '"><span style="margin-right: 6px">' + value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + csy + '</span></div></div>';
                } else {
                  return ""
                }
              }
            },
            cd1:{
              text: "client discount",
              position: 15,
              hidden: vm.$root.token.hidePrices,
              editable: false,
              width: "6%",
              searchable: false,
              sorting: true,
              type: "number",
              datafield: 'cd1',
              cellsalign: 'right',
              cellsrenderer: function (data_row, datafield, value) {
                if(value)return '<div style="text-align: center; margin-top: 10px;">' + value + '</div>';
              }
            }
          }
        }
      },
      options: {
        columnsresize: true,
        columnsreorder: true,
        columnsmenu: vm.$Components[vm.name].options.columnsmenu,
        rowsheight: 40,
        theme: "light",
        width: "100%",
        selectionmode: vm.$Components[vm.name].options.selectionmode ? vm.$Components[vm.name].options.selectionmode : "none",
        cellhover: function (element, pageX, pageY){
          var cell = $('#'+vm.name).jqxGrid('getcellatposition', pageX, pageY);
          var tooltipContent = ''
          var cellValue = vm.arrayToTable[cell.row];

          if(cell.column == 'not'){
            tooltipContent = cellValue.not && cellValue.not != " " ? cellValue.not : cellValue.pnot ? cellValue.pnot : cellValue.notc && cellValue.notc != " " ? cellValue.notc : ''          
          }else if(cell.column == 'doc'){
            tooltipContent = cellValue.doc && cellValue.doc.length>0 ? vm.$Jed.firstUpperTranslate("document", 2)+": "+cellValue.doc.length : ''
          }else if(cell.column == 'val'){
            if(cellValue.val){ 
              if(cellValue.val[0].sv && cellValue.val[0].ev){
                tooltipContent = vm.$Jed.firstUpperTranslate("validity")+" "+vm.$Jed.translate("from") + ": " + cellValue.val[0].sv+" "+vm.$Jed.translate("to") + ": " + cellValue.val[0].ev
              }else if(cellValue.val[0].sv){
                tooltipContent = vm.$Jed.firstUpperTranslate("validity")+" "+vm.$Jed.translate("from") + ": " + cellValue.val[0].sv
              }else if(cellValue.val[0].ev){
                tooltipContent = vm.$Jed.firstUpperTranslate("validity")+" "+vm.$Jed.translate("to") + ": " + cellValue.val[0].ev
              }
            }
          }else if(cell.column == 'des'){
            tooltipContent = cellValue.des ? cellValue.des : ''
          }else if(cell.column == 'spe'){
            tooltipContent = cellValue.spe ? cellValue.spe : ''
          }/* else if(cell.column == 'dis'){
            tooltipContent = vm.$Jed.firstUpperTranslate("availability")+": "+cellValue.ava
          } */
          
          if(tooltipContent && vm.$Components[vm.name].options.hoverableCells && vm.$Components[vm.name].options.hoverableCells.includes(cell.column)){
            $("#"+vm.name).jqxTooltip({content: tooltipContent});
            var x, y;
            if(pageX > 1800){
              x = pageX - 100 //per evitare che il tooltip sia fuori dalla pagina
            }else{
              x = pageX + 15
            }
            if(pageY > 900){
              y = pageY - 20 //per evitare che il tooltip sia fuori dalla pagina
            }else{
              y = pageY + 15
            }
            $("#"+vm.name).jqxTooltip('open', x, y);
          }else{
            $("#"+vm.name).jqxTooltip('destroy');
          }
        },
        showfilterrow: false,
        filterable: true,
        sortable: true,
        pageable: false,
        autoheight: false,
        height: 310,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails:
            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
          rowdetailsheight: 250 /* ! 230 + 20 ! */
        },
        /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
        ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
        initrowdetails: "nested",
        rendered: null,
        ready: function(){
          /* $(".dyn-input-number").keydown(function (e) {
            $("#row0WrapperGrid").children()[0].classList.remove("jqx-grid-cell-selected,jqx-grid-cell-selected-light,jqx-fill-state-pressed,jqx-fill-state-pressed-light")
          }) */
        }
      },
      others:{
        adaptColumns: true
      },
      gridAPI: null,
      chooseQty: false,
      purchaseDes: '',
      purchaseSid: '',
      purchasePrice: '',
      popupHeight: '', 
      product: null, 
      availColl: null,
      minQuantity: 1,
      maxQuantity: 9999999,
      fetchingAvailability: false //se false significa che l'informazione sulla disponibilità la leggo dalla proprietà "ava" recuperata dalla search by father
    };
  },
	watch: {
    focus: function(){
      this.scrollToSelection();
    },
    arrayToTable: function(){
      console.log(this.arrayToTable)
      var vm = this;
      for(var i=0; i<this.arrayToTable.length; i++){
        if( this.arrayToTable[i].sid ) {
          var item = this.$root.shopCartData ? this.$root.shopCartData.prodotti.find( v => {
            return v['codiceProd'] === this.arrayToTable[i].sid || (v['codiceProd'] === this.arrayToTable[i].spi && v['codSost'] === this.arrayToTable[i].sid)
          }) : null
          if( item != null) {
              this.arrayToTable[i]['qca'] = item.quantita;
              $("#popupquantita2Id").val(item.quantita);
              this.arrayToTable[i]['qtc'] = item.quantita;
              $("#qtb_quantitaId"+i).val(item.quantita);
              
          }
        }
        
        /*
        //spostato in Detail.vue per propagare la modifica anche al viewer
        
        if(this.arrayToTable[i].pos == null){
          var zero_pos = Object.keys(this.arrayToTable[i]).sort().find((e)=>e.includes('pos'))
          var first_pos = Object.keys(this.arrayToTable[i]).sort().find((e)=>e.includes('pos') && !this.arrayToTable.some((f)=>{
              var newe = e.replace("pos", '');
              return newe == f.pos && this.arrayToTable[i][zero_pos].sid == f.sid;
            }) )
          if(first_pos != 'pos'){
            //faccio il merge delle prop nell'oggetto di primo livello con quelle dell'oggetto di secondo livello (facendo prevalere quelli del secondo)
            this.arrayToTable[i] = deepExtend(this.arrayToTable[i], this.arrayToTable[i][first_pos])
          }
        }*/
      }

      if(vm.focus != null){
        vm.$nextTick(function(){
          vm.scrollToSelection();
        })
      }
    }
  },  
  methods: {
    async fetchAvailability(){
      this.fetchingAvailability = true;
      var productList = []
      for(var i = 0; i < this.arrayToTable.length; i++){
        productList.push(this.arrayToTable[i].sid);
      }
      if(productList.length>0){
        this.availColl = await this.$root.fetchRegistryData("availability", "GetAvailability", "collection", {pid: {$in: productList}})
      }
      this.fetchingAvailability = false;
      this.$emit("enabled");
      return null;
    },
    closePurchasePopup: function(){
      //console.log('closing Purchase Popup')
      var vm = this;
      vm.chooseQty = false
    },
    setGridHeight: function(){
      var start = this.$store.getters.getLastHeight;
      if(start != null){
         try {
            $('#'+this.name).jqxGrid({
              height: start
            });
          } catch (err) {
            console.log(err)
          }
      }
    },
    rowClicked: function(obj, index) {
      var focusing =
        this.$route.params.focus != obj[this.$Behaviors.focusBy()]
          ? obj[this.$Behaviors.focusBy()]
          : null;

      var existing_query;
      try {
        existing_query = this.$route.query.p;
      } catch (err) {}
      if (focusing) {
        this.$router.push({
          name: "wrapper_focus",
          params: { id: this.$root.encode(obj.fid), focus: focusing },
          query: existing_query ? { p: existing_query } : null
        });
      } else {
        this.$router.push({
          name: "wrapper",
          params: { id: this.$root.encode(obj.fid) },
          query: existing_query ? { p: existing_query } : null
        });
      }
    },
    assignGridAPI: function(e){
      this.gridAPI = e;
    },
    scrollToSelection: function(){
      var vm = this;
      this.$nextTick(function(){
        var selection = vm.gridAPI.getSelection();
        if(selection && selection.length > 0){
          for(var i=0; i<selection.length; i++){ //assicuro che si vedano tutte le righe (es. più parti con la stessa posizione)
            try {
              $('#'+vm.name).jqxGrid('ensurerowvisible', selection[i]);  

              if(vm.$root.fromViewer){
                var h = $('#'+vm.name).jqxGrid('rowsheight')
                $('#'+vm.name).jqxGrid('scrolloffset', h*selection[0], 0); //in questo modo la riga corrispondente viene sempre scrollata in cima (tranne l'ultima riga della tabella che non ha altre righe sotto da scrollare)
                vm.$root.fromViewer = false;
              }
            } catch(err){}
          }
        }
      })
    },
    manageCounter: function(){
      var vm = this;
      //source: www.codeply.com/go/2VmBU7TanF/bootstrap-plus-minus-counter-input
      $('.dyn-btn-number').unbind().click(function(e){ //unbind() per evitare che l'evento si propaghi per più volte
        var fieldName = $(this).attr('data-field'),
            type = $(this).attr('data-type'),
            input = $("input[name='"+fieldName+"']"),
            currentVal = parseFloat(input.val());
        if (!isNaN(currentVal)) {
            if(type == 'minus') {
                if(currentVal > input.attr('min')) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal - 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal - vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal - 1).change();
                  }
                } 
                if(parseFloat(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if(type == 'plus') {
                if(currentVal < input.attr('max')) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal + 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal + vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal + 1).change();
                  }
                }
                if(parseFloat(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
      });

      $('.dyn-input-number').focusin(function(){
        $(this).data('oldValue', $(this).val());
      });

      $('.dyn-input-number').change(function() {
        var minValue =  parseFloat($(this).attr('min')),
            maxValue =  parseFloat($(this).attr('max')),
            valueCurrent = parseFloat($(this).val()), 
            name = $(this).attr('name');
        if(valueCurrent % 1 != 0){ //il valore inserito è decimale?
          if(vm.product.refObj.mqd){
            if(valueCurrent >= minValue) {
              $(".dyn-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('dyn - the minimum value was reached');
              $(this).val(vm.minQuantity);
            }
            if(valueCurrent <= maxValue) {
              $(".dyn-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('dyn - the maximum value was reached');
              $(this).val($(this).data('oldValue'));
            }
          }else{
            $(this).val(vm.minQuantity);
          }
        }else{
          if(vm.product.refObj.pib && (valueCurrent % vm.product.refObj.pib != 0)){ //il valore non è multiplo dei pezzi per confezione
            var mult = parseInt(valueCurrent / vm.product.refObj.pib)
            var correct = vm.product.refObj.pib * mult
            $(this).val(correct);
          }
          if(valueCurrent >= minValue) {
            $(".dyn-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('dyn - the minimum value was reached');
            $(this).val(vm.minQuantity);
          }
          if(valueCurrent <= maxValue) {
            $(".dyn-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('dyn - the maximum value was reached');
            $(this).val($(this).data('oldValue'));
          }
        }
      });

      $(".dyn-input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if(vm.product.refObj.mqd){ //permetto l'inserimento di punti e virgole
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190, 110, 188]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }else{
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    },
    manageCounterInsideGrid: function(row, rowID){
      var vm = this;
      //source: www.codeply.com/go/2VmBU7TanF/bootstrap-plus-minus-counter-input
      $('.dyn-btn-number').unbind().click(function(e){ //unbind() per evitare che l'evento si propaghi per più volte
        var fieldName = $(this).attr('data-field'),
            type = $(this).attr('data-type'),
            input = $("input[name='"+fieldName+"']"),
            currentVal = parseFloat(input.val());
        if (!isNaN(currentVal)) {
            if(type == 'minus') {
                if(currentVal > input.attr('min')) {
                  if(row.mqd){
                    input.val((currentVal - 0.1).toFixed(1)).change();
                    row.qtc = (currentVal - 0.1).toFixed(1)
                  }else if(row.pib){
                    input.val(currentVal - row.pib).change();
                    row.qtc = currentVal - row.pib
                  }else{
                    input.val(currentVal - 1).change();
                    row.qtc = currentVal - 1
                  }
                } 
                if(parseFloat(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if(type == 'plus') {
                if(currentVal < input.attr('max')) {
                  if(row.mqd){
                    input.val((currentVal + 0.1).toFixed(1)).change();
                    row.qtc = (currentVal + 0.1).toFixed(1)
                  }else if(row.pib){
                    input.val(currentVal + row.pib).change();
                    row.qtc = currentVal + row.pib
                  }else{
                    input.val(currentVal + 1).change();
                    row.qtc = currentVal + 1
                  }
                }
                if(parseFloat(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
            row.qtc = 0
        }
        $('#'+vm.name).jqxGrid('updaterow', rowID, row);
      });

      $('.dyn-input-number').focusin(function(){
        $(this).data('oldValue', $(this).val());
      });

      $('.dyn-input-number').change(function() {
        var minValue =  parseFloat($(this).attr('min')),
            maxValue =  parseFloat($(this).attr('max')),
            valueCurrent = parseFloat($(this).val()), 
            name = $(this).attr('name');
        if(valueCurrent % 1 != 0){ //il valore inserito è decimale?
          if(row.mqd){
            if(valueCurrent >= minValue) {
              $(".dyn-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('dyn - the minimum value was reached');
              $(this).val(vm.minQuantity);
            }
            if(valueCurrent <= maxValue) {
              $(".dyn-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('dyn - the maximum value was reached');
              $(this).val($(this).data('oldValue'));
            }
          }else{
            $(this).val(vm.minQuantity);
          }
        }else{
          if(row.pib && (valueCurrent % row.pib != 0)){ //il valore non è multiplo dei pezzi per confezione
            var mult = parseInt(valueCurrent / row.pib)
            var correct = row.pib * mult
            $(this).val(correct);
            row.qtc = correct
          }
          if(valueCurrent >= minValue) {
            $(".dyn-btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('dyn - the minimum value was reached');
            $(this).val(vm.minQuantity);
          }
          if(valueCurrent <= maxValue) {
            $(".dyn-btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('dyn - the maximum value was reached');
            $(this).val($(this).data('oldValue'));
          }
        }
        $('#'+vm.name).jqxGrid('updaterow', rowID, row);
      });

      $(".dyn-input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if(row.mqd){ //permetto l'inserimento di punti e virgole
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190, 110, 188]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }else{
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    },
    /**
     * mette in carrello il prodotto nella quantità specificata
     */
    putInCart: function(){
      var vm = this;
      if(this.product != null) {
        this.product.qty = parseFloat($("#popupquantita2Id").val());
        if( this.product.qty < this.minQuantity || this.product.qty > this.maxQuantity){
          //alert('Superata la quantità minima o massima ammessa per questo prodotto');
          eventBus.$emit('alert', {
            message: this.$Jed.firstUpperTranslate('Warning: minimum quantity is %1$s', null, {key: null, string: this.minQuantity}),
            type: "warning",
            action: ''
          })
          return;
        }
        var qty = this.$root.addProductToCart(this.product);
        this.$root.saveDraft();
        if( this.product.refObj ) this.product.refObj.qca = qty;

        var indexes = [], i;
        for(i = 0; i < this.arrayToTable.length; i++){
          if (this.arrayToTable[i].sid === this.product.refObj.sid){
            indexes.push(i);
          }
        }
        
        if(indexes.length > 0) {
          for(i = 0; i < this.arrayToTable.length; i++){
            if(indexes.includes(i)){
              this.arrayToTable[i]['qca'] = ((qty && qty > 0) ? qty : '');
            }
          }
        }
        
        $("#popupquantita2Id").val(((qty && qty > 0) ? qty : ''));
        $('#'+vm.name).jqxGrid('updatebounddata','cells');
      }
      this.closePurchasePopup();
    },
    putInCartInsideGrid: function(i){
      var vm = this;
      if(this.product != null) {
        this.product.qty = parseFloat($("#qtb_quantitaId"+i).val());
        if( this.product.qty == "" || isNaN(this.product.qty) || this.product.qty < this.minQuantity || this.product.qty > this.maxQuantity){
          //alert('Superata la quantità minima o massima ammessa per questo prodotto');
          eventBus.$emit('alert', {
            message: this.$Jed.firstUpperTranslate('Warning: minimum quantity is %1$s', null, {key: null, string: this.minQuantity}),
            type: "warning",
            action: ''
          })
          return;
        }
        var qty = this.$root.addProductToCart(this.product);
        if(qty && qty>0){
          this.$root.saveDraft();
          if( this.product.refObj ) this.product.refObj.qca = qty;

          this.arrayToTable[i]['qca'] = qty
          this.arrayToTable[i]['qtc'] = qty
          $('#'+vm.name).jqxGrid('updatebounddata','cells');
        }
      }
    },
    cartClick: function(obj, event){
      var vm = this;
      if(!vm.$Configs.ecp.ecidUrl){ 
        if(vm.$root.preferences.useOffline){
          var len = vm.$root.dbServRegistry.collections.length != vm.$root.front_end_configs.collectionsInServReg
          var len2 = vm.$root.dbRegistry.collections.length != vm.$root.front_end_configs.collectionsInIdb
          var cond = vm.$root.dbServRegistry == null || vm.$root.dbRegistry == null || len || len2
          console.log(cond)
          if(cond){
              eventBus.$emit('alert', {
                  message: vm.$Jed.firstUpperTranslate('your data are loading. Try again in a few seconds.'), 
                  type: "warning" 
              })
              return;
          }
        }
        //il click sull'icona del carrello non deve innescare la chiusura del popup di acquisto
        //console.log(event)
        event.stopPropagation(); //fermo la propagazione dell'evento di click in modo che non si inneschi la chiusura del popup
        $('#purchasePopup').mousedown(function(event){ //il click sull'area che comprende il popup non ne innesca la chiusura
          //console.log('purchasePopup click event')
          event.stopPropagation();
        });
        if(vm.$root.shopCartData == null){
          /* eventBus.$emit('alert', {
              message: vm.$Jed.firstUpperTranslate('unable to start cart'), 
              type: "warning" 
          })
          return */
          if(!vm.$Configs.ecp.ecidUrl){
                vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
            }
            var tempId = this.$root.getTempReferenceId();
        }
        vm.manageCounter();
        var tabWrapCont = $("#tableWrapperContainer"),
            containerH = tabWrapCont.css('height'),
            delta = window.innerHeight - event.clientY,
            topcont;
        if(tabWrapCont.parent('div#table-layout').length && event.clientY < 468){ 
          //se sono nella visualizzazione solo tabella e se ho cliccato non troppo in basso
          //il popup compare in basso rispetto all'icona carrello e la freccina è nella parte alta del popup
          topcont = parseInt(containerH) - delta - 20;
          $('.popup-arrow').css('top', '2px')
          $('.popup-arrow-border').css('top', '2px')
        }else{
          //negli altri casi, il popup compare in alto rispetto all'icona carrello e la freccina è nella parte bassa del popup
          topcont = parseInt(containerH) - delta - 180;
          $('.popup-arrow').css('top', '168px')
          $('.popup-arrow-border').css('top', '168px')
        }
        console.log(obj)
        this.minQuantity = obj.mqt;
        if(obj.salable){
          vm.product = {
            cod: obj.sid,
            spi: obj.spi,
            qty: obj.qty && obj.qty >= obj.mqt ? obj.qty : obj.mqt,
            descr: obj.spdes ? obj.spdes : obj.des,
            unitmis: obj.uni,
            refObj: obj,
            csy: vm.$root.token.valuta,
            mqt: obj.mqt
          };
          console.log(vm.product)
          if(obj.qca){
            $("#popupquantita2Id").val(obj.qca);
          }else{
            $("#popupquantita2Id").val(vm.product && vm.product.qty ? vm.product.qty : 1);
          }
          $("#popupquantita2Id").attr('min', vm.minQuantity);
          $("#popupquantita2Id").attr('max', vm.maxQuantity);
          if(vm.chooseQty){
            vm.chooseQty = false
          }else{
            vm.chooseQty = true
            $("#purchasePopup").css('top', topcont); //sposto il popup, non la freccina
            vm.purchaseDes = vm.product.descr
            vm.purchaseSid = vm.product.spi ? vm.product.spi : vm.product.cod
            var pp = (obj.pri ? obj.pri : obj.origin ? obj.origin : "")
            pp = pp.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            vm.purchasePrice = !vm.$root.token.hidePrices ? pp + " " + vm.$root.token.valuta : null
            vm.popupHeight = vm.purchasePrice != null ? 'height: 220px;' : 'height: 200px;'
          } 
        }
      }else{ //chiamata a e-commerce
        if(vm.$Configs.ecp.tipoIntegrazione.includes("vai a pagina e-commerce")){
          var ecurl = vm.$Configs.ecp.ecidUrl
          ecurl += '?partcode='+ encodeURIComponent(obj.spi || obj.sid)
          var win = window.open(ecurl, '_blank');
          win.focus();
        }
      }
    }
  }
};
</script>

<style lang="scss">

  .truncEllipsisMultiline{
    font-size: 15px; 
    padding-left: 4px; 
    padding-top: 4px; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .popup-arrow {
    width: 0px;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid rgb(220, 235, 245);
    display: table-cell;
    position: absolute;
    z-index: 9998;
    right: 199px;
    top: 168px;
  }

  .popup-arrow-border{
    width: 0px;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-right: 16px solid rgb(167, 199, 220);
    display: table-cell;
    position: absolute;
    z-index: 9998;
    right: 199px;
    top: 168px;
  }

  /* #gridmenuWrapperGrid{
    position: fixed !important;
    top: auto !important;
    bottom: 310px;
  } */

  .accordion{
    background-color: #eee;
    color: #444;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 15px;
    transition: 0.4s;
  }

  .accordion:after {
    content: '\02795'; /* Unicode character for "plus" sign (+)*/
    font-size: 9px;
    color: #777;
    float: right;
    margin-left: 5px;
  }

  .accordion-content{
    padding: 0 18px;
    display: none;
    background-color: white;
    overflow: hidden;
  }

  .icon-stack{
    position: absolute; 
    left: 0; 
    width: 100%; 
    text-align: center; 
    display: table-cell; 
    vertical-align: middle; 
    font-size: 1.8em;
  }

  .icon-stack-1x{
    display: table-cell; 
    vertical-align: middle; 
    font-size: 1.2em;
  }

  .icon-stack-2x{
    display: table-cell; 
    vertical-align: middle; 
    font-size: 1.8em;
  }

  div.jqx-grid-cell-selected a {
    color: white !important;
  }

  .sweet-modal.has-tabs:not(.has-title) .sweet-title {
    height: 44px !important;
  }

  .sweet-modal .sweet-title{
    height: 50px;
  }

  .sweet-modal .sweet-title > h2{
      margin-top: 15px;
      margin-bottom: 5px;
  }

  .sweet-modal .sweet-box-actions .sweet-action-close {
    display: table !important;
    cursor: pointer !important;
    color: white !important;
    text-align: center !important;
    width: 0px !important;
    height: 0px !important;
    line-height: 0px !important;
    border-radius: 50% !important;
    &:hover {
      background: none !important;
      color: none !important;
    }
  }

  .sweet-modal-overlay {
    background: rgba(255, 255, 255, 0.65) !important;
  }

  .sweet-action-close:hover {
    background-color: none !important;
  }

 /*  .form-control:focus {
    border-color: #d2d6de !important;
  } */
</style>


// WEBPACK FOOTER //
// src/components/dynamic/DynTableWrapper.vue?55fd9205